import {
  CreditCardToolbox20Regular,
  DismissRegular,
  SignOut20Regular,
} from '@fluentui/react-icons';
import useMixpanel from 'hooks/useMixpanel';
import React from 'react';
import { ReactComponent as BusinessLogo } from 'assets/BusinessLogo.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'constants/routes';
import { RootState } from 'store';
import { useAppSelector } from 'hooks/useRedux';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { usePayoutMethodsQuery } from 'store/apis/payoutApi';
import { PayoutMethodEnum } from 'enum/common';
interface IHeaderPopoverContentProps {
  authContext: any;
  setOpen: Function;
  onClose: () => void;
}

const HeaderPopoverContent: React.FC<IHeaderPopoverContentProps> = ({
  authContext,
  setOpen,
  onClose,
}) => {
  const { trackEvent } = useMixpanel();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const defaultAccount = useAppSelector((state: RootState) => state.defaultAccount.defaultAccount);
  const [selectedBusiness] = useLocalStorage('selectedBusiness', null);

  const navigateToBusiness = () => {
    navigate(`${routes.chooseBusiness}/1`, {
      state: { restrictBusinessRefresh: true },
    });
    onClose();
  };

  const logout = () => authContext?.logout();

  const { data: payoutMethod } = usePayoutMethodsQuery({
    uuid: selectedBusiness?.uuid || '',
    type: PayoutMethodEnum.DEFAULT,
  });

  const options = [
    {
      show: !pathname.includes(routes?.chooseBusiness),
      icon: <BusinessLogo className="w-5 h-5" />,
      text: 'Switch Business',
      textClass: 'text-gray-700',
      action: () => {
        trackEvent('choose_business_dropdown_Clicking');
        navigateToBusiness();
      },
    },
    {
      show:
        (!!payoutMethod || !!defaultAccount) &&
        pathname !== routes?.paymentManagement &&
        !pathname.includes(routes?.onboardingBusiness),
      icon: <CreditCardToolbox20Regular className="w-5 h-5" />,
      text: 'Payment Management',
      textClass: 'text-gray-700',
      action: () => {
        trackEvent('payment_management_click');
        navigate(routes.paymentManagement);
        onClose();
      },
    },
    {
      show: true,
      icon: <SignOut20Regular className="w-5 h-5 text-red-500" />,
      text: 'Signout',
      textClass: 'text-red-500',
      action: () => {
        trackEvent('signout_Clicking');
        logout();
      },
    },
  ];

  const filteredOptions = options.filter((option) => !!option.show);

  return (
    <div className="flex flex-col min-w-[160px] relative">
      {/* Close Button - Top Right Corner */}
      <DismissRegular
        className="absolute -top-1 -right-1 cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
        fontSize={16}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />

      {/* Menu Options */}
      <div className="flex flex-col mt-2">
        {filteredOptions?.map((option, index) => (
          <button
            key={option?.text.toString()}
            onClick={() => option?.action()}
            className={`flex items-center gap-2.5 px-1 py-2 rounded-md cursor-pointer transition-all duration-200 hover:bg-gray-50 active:bg-gray-100 w-full text-left ${
              index === filteredOptions.length - 1 ? 'mt-1 pt-2 border-t border-gray-100' : ''
            }`}
          >
            <span className="flex-shrink-0">{option?.icon}</span>
            <span className={`font-poppins text-sm font-medium ${option.textClass}`}>
              {option?.text}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default HeaderPopoverContent;
